module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-ameba.594c8056.png";